module.exports = __webpack_public_path__ + "static/media/deen-label.9af32498.png";